import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
  staff: {
    region: "",
    territory: "",
    manager: "",
  },
  facilityCoverage: {
    region: "",
    territory: "",
    zone: "",
  },
  date: new Date(),
};

export const scheduleFilter = createAsyncThunk(
  "schedule/filter",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.eventFilterList(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const scheduleFilterSlice = createSlice({
  name: "scheduleFilter",
  initialState,
  reducers: {
    setFilter(state, action) {
      const { parent, property, value } = action.payload;
      state[parent] = {
        ...state[parent],
        [property]: value,
      };
    },
    setDate(state, action) {
      state.date = action.payload;
    },
    setFilterObject(state, action) {
      const { property, value } = action.payload;
      state[property] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(scheduleFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(scheduleFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(scheduleFilter.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const scheduleFilterList = (state) => state.scheduleFilter.value;

export const filterState = (state) => state.scheduleFilter;

export const { setFilter, setDate, setFilterObject } =
  scheduleFilterSlice.actions;

export default scheduleFilterSlice.reducer;
